<div class="modal permit-menu" [ngClass]="'modal--' + mode" *transloco="let t; read:'permit.createModal'">
    <div class="modal__close" (click)="closeModal()"></div>

    <div class="modal__content" (click)="closeIfMobile()">
        <div class="modal__options">
            <ng-container [ngSwitch]="mode">
                <!-- Premium options -->
                <ng-container *ngSwitchCase="PermitCreateMode.Premium">
                    <div class="option option--premium" (click)="openPremiumInfo($event)">
                        <div class="option__icon option__icon--premium desktop-only"></div>
                        <span [innerHTML]="t('premium')"></span>
                        <div class="option__icon option__icon--premium mobile-only"></div>
                    </div>
                     <div *ngIf="hasDelegationsToReturn$ | async" class="option" (click)="onReturnDelegatedPermit($event)">
                        <div class="option__icon option__icon--return desktop-only"></div>
                        <span>{{t('returnDelegatedPermit')}}</span>
                        <div class="option__icon option__icon--return mobile-only"></div>
                    </div>
                    <div *ngIf="(hasValidCertificate$ | async)" class="option" (click)="onGetPreparedPermit($event)">
                        <div class="option__icon option__icon--portal desktop-only"></div>
                        <span>{{t('getPreparedPremium')}}</span>
                        <div class="option__icon option__icon--portal mobile-only"></div>
                    </div>
                    <div *ngIf="(hasValidCertificate$ | async)" class="option" (click)="onPreparePermit($event)">
                        <div class="option__icon option__icon--vacuum desktop-only"></div>
                        <span>{{t('preparePremiumWithCode')}}</span>
                        <div class="option__icon option__icon--vacuum mobile-only"></div>
                    </div>
                    <div *ngIf="(currentPerson$ | async).concept === ConceptType.HetaArbeten" class="option" (click)="onCreateDemo($event, false)">
                        <div class="option__icon option__icon--flask desktop-only"></div>
                        <span>{{t('newBaseDemoPermit')}}</span>
                        <div class="option__icon option__icon--flask mobile-only"></div>
                    </div>
                    <div *ngIf="(hasValidCertificate$ | async) && (currentPerson$ | async).concept === ConceptType.HetaArbeten" class="option" (click)="onCreatePermit($event, false)">
                        <div class="option__icon option__icon--pen desktop-only"></div>
                        <span>{{t('newBasePermit')}}</span>
                        <div class="option__icon option__icon--pen mobile-only"></div>
                    </div>
                    <div *ngIf="(currentPerson$ | async).isPremiumSuperintendent" class="option" (click)="onCreatePermit($event, true, PermitType.flammableAtex)">
                        <div class="option__icon option__icon--triangle-exclamation desktop-only"></div>
                        <span>{{t('newFlammableAtexPermit')}}</span>
                        <div class="option__icon option__icon--triangle-exclamation mobile-only"></div>
                    </div>
                    <div *ngIf="(currentPerson$ | async).isPremiumSuperintendent" class="option" (click)="onCreateDemo($event, true, PermitType.flammableAtex)">
                        <div class="option__icon option__icon--flask desktop-only"></div>
                        <span>{{t('newDemoFlammableAtexPermit')}}</span>
                        <div class="option__icon option__icon--flask mobile-only"></div>
                    </div>
                    <div class="option" (click)="onCreateDemo($event, true)">
                        <div class="option__icon option__icon--flask desktop-only"></div>
                        <span>{{t('newPremiumDemoPermit')}}</span>
                        <div class="option__icon option__icon--flask mobile-only"></div>
                    </div>
                    <div *ngIf="(hasValidCertificate$ | async)" class="option option--primary" (click)="onCreatePermit($event, true)">
                        <div class="option__icon option__icon--pen desktop-only"></div>
                        <span>{{t('newPremiumPermit')}}</span>
                        <div class="option__icon option__icon--pen mobile-only"></div>
                    </div>
                </ng-container>

                <!-- Base options -->
                <ng-container *ngSwitchCase="PermitCreateMode.Base">
                    <div class="option option--premium" (click)="openPremiumInfo($event)">
                        <div class="option__icon option__icon--premium desktop-only"></div>
                        <span [innerHTML]="t('premium')"></span>
                        <div class="option__icon option__icon--premium mobile-only"></div>
                    </div>
                                            <div *ngIf="hasDelegationsToReturn$ | async" class="option" (click)="onReturnDelegatedPermit($event)">
                        <div class="option__icon option__icon--return desktop-only"></div>
                        <span>{{t('returnDelegatedPermit')}}</span>
                        <div class="option__icon option__icon--return mobile-only"></div>
                    </div>
                    <div *ngIf="(hasValidCertificate$ | async)" class="option" (click)="onPreparePermit($event)">
                        <div class="option__icon option__icon--vacuum desktop-only"></div>
                        <span>{{t('preparePremiumWithCode')}}</span>
                        <div class="option__icon option__icon--vacuum mobile-only"></div>
                    </div>
                    <div class="option" (click)="onCreateDemo($event, false)">
                        <div class="option__icon option__icon--flask desktop-only"></div>
                        <span>{{t('newBaseDemoPermit')}}</span>
                        <div class="option__icon option__icon--flask mobile-only"></div>
                    </div>
                    <div *ngIf="(currentPerson$ | async).isPremiumSuperintendent" class="option" (click)="onCreatePermit($event, true, PermitType.flammableAtex)">
                        <div class="option__icon option__icon--triangle-exclamation desktop-only"></div>
                        <span>{{t('newFlammableAtexPermit')}}</span>
                        <div class="option__icon option__icon--triangle-exclamation mobile-only"></div>
                    </div>
                    <div *ngIf="(currentPerson$ | async).isPremiumSuperintendent" class="option" (click)="onCreateDemo($event, true, PermitType.flammableAtex)">
                        <div class="option__icon option__icon--flask desktop-only"></div>
                        <span>{{t('newDemoFlammableAtexPermit')}}</span>
                        <div class="option__icon option__icon--flask mobile-only"></div>
                    </div>
                    <div *ngIf="(hasValidCertificate$ | async)" class="option option--primary" (click)="onCreatePermit($event, false)">
                        <div class="option__icon option__icon--pen desktop-only"></div>
                        <span>{{t('newBasePermit')}}</span>
                        <div class="option__icon option__icon--pen mobile-only"></div>
                    </div>
                </ng-container>

                <!-- Demo options -->
                <ng-container *ngSwitchCase="PermitCreateMode.Demo">
                    <div class="option option--premium" (click)="openPremiumInfo($event)">
                        <div class="option__icon option__icon--premium desktop-only"></div>
                        <span [innerHTML]="t('premium')"></span>
                        <div class="option__icon option__icon--premium mobile-only"></div>
                    </div>
                    <div class="option option--primary" (click)="onCreateDemo($event, false)">
                        <div class="option__icon option__icon--pen desktop-only"></div>
                        <span>{{t('newBaseDemoPermit')}}</span>
                        <div class="option__icon option__icon--pen mobile-only"></div>
                    </div>
                </ng-container>

                <!-- Superintendent options -->
                <ng-container *ngSwitchCase="PermitCreateMode.Superintendent">
                    <div class="option" (click)="onCreatePermit($event, true, PermitType.flammableAtex)">
                        <div class="option__icon option__icon--triangle-exclamation desktop-only"></div>
                        <span>{{t('newFlammableAtexPermit')}}</span>
                        <div class="option__icon option__icon--triangle-exclamation mobile-only"></div>
                    </div>
                    <div class="option option--primary" (click)="onCreateDemo($event, true, PermitType.flammableAtex)">
                        <div class="option__icon option__icon--flask desktop-only"></div>
                        <span>{{t('newDemoFlammableAtexPermit')}}</span>
                        <div class="option__icon option__icon--flask mobile-only"></div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
    <div class="modal__actions">
        <button class="modal__actions__close" type="button" (click)="closeModal()">{{t('close')}}</button>
    </div>
</div>
